export const MONTHLY_RATE_LOOKUPS = [
  {
    $lookup: {
      from: "non_plantilla",
      localField: "nonRegPosition.id",
      foreignField: "_id",
      as: "nonRegPositionLookup",
    },
  },
  {
    $lookup: {
      from: "salary_grade",
      let: { code: "$salaryCode" },
      pipeline: [
        {
          $match: {
            $expr: {
              $and: [
                { $eq: ["$salaryCode", "$$code"] },
                { $eq: ["$status", "active"] },
              ],
            },
          },
        },
        { $sort: { createdAt: -1 } },
        { $limit: 1 },
        { $project: { _id: 0, "Monthly Rate": 1 } },
      ],
      as: "salaryGradeLookup",
    },
  },
];
